import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const SideMenu: React.FC = () => {
    const location = useLocation();
    // Dropdown state: key is dropdown id, value is open/closed
    const [openDropdown, setOpenDropdown] = useState<string | null>(null);
    const toggleDropdown = (id: string) => {
        setOpenDropdown(openDropdown === id ? null : id);
    };

    const isClinicianRoute = location.pathname.startsWith('/institution/clinician') || location.pathname === '/institution/dashboard/clinician';
    const isFacilityRoute = location.pathname.startsWith('/institution/facility') || location.pathname === '/institution/dashboard/facility';
    const isProviderRoute = location.pathname.startsWith('/institution/provider') || location.pathname === '/institution/home';

    return (
        <>
        <style>{`
          /* Fix for Bootstrap collapse when using Tailwind */
          .collapse:not(.show) { display: none !important; }
          .collapse.show { display: block !important; }
        `}</style>

        <div className="app-menu navbar-menu">

            <div className="navbar-brand-box">

                <Link to={"/institution/home"} className="logo logo-dark">
                    <span className="logo-sm">
                        <div className="d-flex align-items-center">
                            <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-1" style={{ width: 48, height: 48 }}>
                                <span className="text-white fw-bold" style={{ fontSize: '20px' }}>U</span>
                            </div>
                        </div>
                    </span>
                    <span className="logo-lg">
                        <div className="d-flex align-items-center">
                            <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-2" style={{ width: 24, height: 24 }}>
                                <span className="text-white fw-bold" style={{ fontSize: '12px' }}>U</span>
                            </div>
                            <span className="fw-bold text-primary" style={{ fontSize: '14px' }}>UZIMA</span>
                        </div>
                    </span>
                </Link>

                <Link to={"/institution/home"} className="logo logo-light">
                    <span className="logo-sm">
                        <div className="d-flex align-items-center">
                            <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-1" style={{ width: 22, height: 22 }}>
                                <span className="text-white fw-bold" style={{ fontSize: '10px' }}>U</span>
                            </div>
                        </div>
                    </span>
                    <span className="logo-lg">
                        <div className="d-flex align-items-center">
                            <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-2" style={{ width: 44, height: 44 }}>
                                <span className="text-white fw-bold" style={{ fontSize: '18px' }}>U</span>
                            </div>
                            <span className="fw-bold text-primary" style={{ fontSize: '16px' }}>UZIMA</span>
                        </div>
                    </span>
                </Link>
                <button type="button" className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover" id="vertical-hover">
                    <i className="ri-record-circle-line"> </i>
                </button>
            </div>

            <div id="scrollbar">
                <div className="container-fluid">

                    <div id="two-column-menu">
                    </div>
                    <ul className="navbar-nav" id="navbar-nav">
                        <li className="menu-title"><span data-key="t-menu">Menu</span></li>
                        <li className="nav-item">
                            <Link className="nav-link menu-link" to={"/institution/home"} >
                                <i className="bx bxs-dashboard"> </i> <span data-key="t-dashboards">Uzima Dashboard</span>
                            </Link>
                        </li>

                        <li className={"nav-item"}>
                            <button type="button" className="nav-link menu-link w-full text-left" onClick={() => toggleDropdown("sidebarDashboards")}>
                                <i className="bx bx-layout"> </i> <span data-key="t-provider-dashboards">Provider Dashboards</span>
                            </button>
                            <div className={openDropdown === "sidebarDashboards" ? "menu-dropdown block" : "menu-dropdown hidden"} id="sidebarDashboards">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item">
                                        <Link to={"/institution/home"} className="nav-link">
                                            <i className="bx bx-briefcase-alt-2 me-2"></i>General Service Provider
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/dashboard/clinician"} className="nav-link">
                                            <i className="bx bx-plus-medical me-2"></i>Clinician Dashboard
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/dashboard/facility"} className="nav-link">
                                            <i className="bx bx-buildings me-2"></i>Facility Dashboard
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        {(isProviderRoute || isClinicianRoute || isFacilityRoute) && (
                            <>
                                <li className="menu-title">
                                    <span>{isClinicianRoute ? 'Clinician Workspace' : isFacilityRoute ? 'Facility Workspace' : 'Provider Workspace'}</span>
                                </li>
                                {isProviderRoute && (
                                    <>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/provider/service-center">
                                                <i className="bx bx-layer"></i> <span>Service Center</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/provider/collaborations">
                                                <i className="bx bx-link-alt"></i> <span>Collaborations</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/provider/resources">
                                                <i className="bx bx-book-open"></i> <span>Resources</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/provider/subscription">
                                                <i className="bx bx-credit-card"></i> <span>My Subscription</span>
                                            </Link>
                                        </li>
                                    </>
                                )}
                                {isClinicianRoute && (
                                    <>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/ehr">
                                                <i className="bx bx-notepad"></i> <span>Clinical Records</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/ehr/new">
                                                <i className="bx bx-plus-circle"></i> <span>New Medical Record</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/schedule">
                                                <i className="bx bx-calendar"></i> <span>Schedule & Appointments</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/patients">
                                                <i className="bx bx-user-circle"></i> <span>My Patients</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/prescriptions">
                                                <i className="ri-capsule-line"></i> <span>Prescriptions & Orders</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/referrals">
                                                <i className="bx bx-transfer-alt"></i> <span>Referrals</span>
                                            </Link>
                                        </li>

                                        <li className="menu-title"><span>Collaborative Care</span></li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/care-plans">
                                                <i className="ri-heart-pulse-line"></i> <span>Shared Care Plans</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/diagnostics">
                                                <i className="ri-microscope-line"></i> <span>Lab & Diagnostics</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/collaborations">
                                                <i className="bx bx-link-alt"></i> <span>Collaboration Workspace</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/consultations">
                                                <i className="ri-stethoscope-line"></i> <span>Consultation Requests</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/telehealth">
                                                <i className="bx bx-video"></i> <span>Telehealth</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/templates">
                                                <i className="ri-file-list-3-line"></i> <span>Clinical Notes & Templates</span>
                                            </Link>
                                        </li>

                                        <li className="menu-title"><span>Practice & Growth</span></li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/protocols">
                                                <i className="ri-git-branch-line"></i> <span>Clinical Protocols</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/quality">
                                                <i className="ri-bar-chart-grouped-line"></i> <span>Quality & Outcomes</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/education">
                                                <i className="ri-graduation-cap-line"></i> <span>Continuing Education</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/contracts">
                                                <i className="bx bx-file-blank"></i> <span>Contracts & Engagements</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/resources">
                                                <i className="ri-booklet-line"></i> <span>Resources</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/notifications">
                                                <i className="bx bx-bell"></i> <span>Notifications</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/clinician/subscription">
                                                <i className="bx bx-credit-card"></i> <span>My Subscription</span>
                                            </Link>
                                        </li>
                                    </>
                                )}
                                {isFacilityRoute && (
                                    <>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/network">
                                                <i className="ri-global-line"></i> <span>Partner Network</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/referrals">
                                                <i className="bx bx-transfer-alt"></i> <span>Referral Center</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/services">
                                                <i className="ri-store-2-line"></i> <span>Service Marketplace</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/collaborations">
                                                <i className="bx bx-link-alt"></i> <span>Collaboration Workspace</span>
                                            </Link>
                                        </li>

                                        <li className="menu-title"><span>Patient Coordination</span></li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/patients">
                                                <i className="bx bx-user-circle"></i> <span>Shared Patient Care</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/contracts">
                                                <i className="bx bx-file-blank"></i> <span>Contracts & Agreements</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/accounting">
                                                <i className="ri-bank-card-2-line"></i> <span>Billing & Settlement</span>
                                            </Link>
                                        </li>

                                        <li className="menu-title"><span>Organization</span></li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/staff">
                                                <i className="bx bx-group"></i> <span>Staff & Team</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/equipment">
                                                <i className="ri-charging-pile-2-line"></i> <span>Shared Equipment</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/facilities">
                                                <i className="bx bx-buildings"></i> <span>Facility Profile</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/compliance">
                                                <i className="ri-shield-check-line"></i> <span>Quality & Accreditation</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/stakeholders">
                                                <i className="ri-group-line"></i> <span>Stakeholder Relations</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/reports">
                                                <i className="ri-line-chart-line"></i> <span>Reports & Insights</span>
                                            </Link>
                                        </li>

                                        <li className="menu-title"><span>Settings</span></li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/management">
                                                <i className="bx bx-cog"></i> <span>Facility Settings</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/resources">
                                                <i className="ri-booklet-line"></i> <span>Resources</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/notifications">
                                                <i className="bx bx-bell"></i> <span>Notifications</span>
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link className="nav-link menu-link" to="/institution/facility/subscription">
                                                <i className="bx bx-credit-card"></i> <span>Subscription & Licensing</span>
                                            </Link>
                                        </li>
                                    </>
                                )}
                            </>
                        )}

                        {!isClinicianRoute && !isFacilityRoute && (<>
                        <li className="menu-title">
                            <i className="ri-more-fill">

                            </i>
                            <span data-key="t-components"> Uzima Community </span>
                        </li>

                        <li className={"nav-item"}>
                            <button type="button" className="nav-link menu-link w-full text-left" onClick={() => toggleDropdown("sidebarBrowse")}>
                                <i className="bx bx-server"> </i> <span data-key="t-browse">Uzima Services Center</span>
                            </button>
                            <div className={openDropdown === "sidebarBrowse" ? "menu-dropdown block" : "menu-dropdown hidden"} id="sidebarBrowse">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item">
                                        <Link to={"/institution/service-center"} className="nav-link" data-key="t-calendar"> 
                                            <i className="bx bx-home-alt me-2"></i>Service Center
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/services/my-services"} className="nav-link" data-key="t-calendar"> 
                                            <i className="bx bx-layer-group me-2"></i>My Services
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/services/categories"} className="nav-link" data-key="t-chat">
                                            <i className="bx bx-category me-2"></i>Categories
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/services/pricing"} className="nav-link" data-key="t-chat">
                                            <i className="bx bx-dollar-circle me-2"></i>Pricing
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/services/analytics"} className="nav-link" data-key="t-chat">
                                            <i className="bx bx-bar-chart-alt-2 me-2"></i>Analytics
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li className="nav-item">
                            <button type="button" className="nav-link menu-link w-full text-left" onClick={() => toggleDropdown("sidebarCommunication")}>
                                <i className="bx bx-phone "> </i> <span data-key="t-comms">Telehealth Center</span>
                            </button>
                            <div className={openDropdown === "sidebarCommunication" ? "menu-dropdown block" : "menu-dropdown hidden"} id="sidebarCommunication">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item">
                                        <Link to="/institution/telehealth" className="nav-link"
                                              data-key="t-products"> 
                                            <i className="bx bx-video me-2"></i>Telehealth Center
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/institution/telehealth/schedule" className="nav-link"
                                              data-key="t-products"> 
                                            <i className="bx bx-calendar me-2"></i>Schedule Session
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/institution/telehealth/devices" className="nav-link"
                                              data-key="t-products"> 
                                            <i className="bx bx-chip me-2"></i>IoT Devices
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/institution/telehealth/history" className="nav-link"
                                              data-key="t-products"> 
                                            <i className="bx bx-history me-2"></i>Session History
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/institution/telehealth/messaging" className="nav-link"
                                              data-key="t-products"> 
                                            <i className="bx bx-message me-2"></i>Secure Chat
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/institution/notifications" className="nav-link"
                                              data-key="t-products"> 
                                            <i className="bx bx-bell me-2"></i>Notifications
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/institution/messaging" className="nav-link"
                                              data-key="t-products"> 
                                            <i className="bx bx-message me-2"></i>Messaging Hub
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/institution/communication" className="nav-link"
                                              data-key="t-product-Details"> 
                                            <i className="bx bx-phone me-2"></i>E-Conferencing
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/institution/document_exchange" className="nav-link"
                                              data-key="t-orders"> 
                                            <i className="bx bx-file me-2"></i>Document Exchange 
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li className="nav-item">
                            <button type="button" className="nav-link menu-link w-full text-left" onClick={() => toggleDropdown("sidebarCollaborationTools")}>
                                <i className="bx bx-chip "> </i> <span data-key="t-collab">Collaboration Center</span>
                            </button>
                            <div className={openDropdown === "sidebarCollaborationTools" ? "menu-dropdown block" : "menu-dropdown hidden"} id="sidebarCollaborationTools">
                                <ul className="nav nav-sm flex-column">

                                    <li className="nav-item">
                                        <Link to="/institution/collaborations" className="nav-link"
                                              data-key="t-products"> Launch App
                                        </Link>

                                    </li>

                                    <li className="nav-item">
                                        <Link to="/institution/messaging?context_type=collaboration" className="nav-link"
                                              data-key="t-products"> Collaboration Messages
                                        </Link>

                                    </li>

                                    <li className="nav-item">
                                        <Link to="/institution/collaborations/find-requests" className="nav-link"
                                              data-key="t-products"> Find Requests <span className="topbar-badge badge rounded-pill bg-success">0 </span>
                                        </Link>

                                    </li>

                                    <li className="nav-item">

                                        <Link to="/institution/collaborations/partnership-requests" className="nav-link"
                                              data-key="t-products"> Partnership Requests <span className="topbar-badge badge rounded-pill bg-success">0 </span>
                                        </Link>
                                        {/*
                                            - give service type (perma engagement, term engangement[specify duration: locums etc])
                                            - give service description (200 char)
                                            - partnership framework [select someone based on quals and make agreements(professionals)] base on payment per persion or request, specify response time... respond on time, give price guide or checkbox to specify, expected volume of work, other field
                                            -
                                           */}
                                    </li>

                                    <li className="nav-item">
                                        <Link to="/institution/collaborations/received-requests" className="nav-link"
                                              data-key="t-product-Details"> Received Requests
                                        </Link>

                                        {/*
                                            - accept request terms or give counter offer
                                            - text field: clarify
                                            - price counter offer & negotiates

                                        */}
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/institution/collaborations/accounting" className="nav-link"
                                              data-key="t-orders"> Accounting </Link>



                                        {/*
                                        - pick up the summary of transactions which are open or pending
                                        - amounts invoiced/open
                                        - summary per partner
                                        - amounts invoiced to you by your partners for the transaction
                                        - amounts invoiced to patients against a particular service or send someone to pay direct

                                        */}

                                        {/*
                                            - patient journey map logging... should be one record that can be followed until when the patient has been served
                                            - summary of a partner (transactions for partners in a period)
                                        */}
                                    </li>

                                    <li className="nav-item">
                                        <Link to="/institution/patients" className="nav-link"
                                              data-key="t-orders"> Patient Center </Link>



                                        {/*
                                            - view records associated with the patients at the various stages... go to reports or patient center
                                            - patient status and which partner is attending to the patient
                                            - medication history for the patient

                                        */}
                                    </li>

                                    <li className="nav-item">
                                        <Link to="/institution/collaborations/reports" className="nav-link"
                                              data-key="t-orders"> Resources & Reports </Link>



                                        {/*
                                            - view records associated with the patients at the various stages... go to reports or patient center
                                            - patient status and which partner is attending to the patient
                                            - medication history for the patient

                                        */}
                                    </li>

                                    <li className="nav-item">
                                        <Link to="/institution/collaborations/reports" className="nav-link"
                                              data-key="t-orders"> Resources </Link>
                                        {/*
                                            - find active forums of uzima
                                            - downloads
                                            - webinars,
                                            - tcs
                                            - IoT

                                        */}
                                    </li>


                                </ul>
                            </div>
                        </li>

                        <li className="nav-item">
                            <button type="button" className="nav-link menu-link" onClick={() => toggleDropdown("sidebarApps")}>
                                <i className="bx bx-layer"> </i> <span data-key="t-apps">Uzima - Apps</span>
                            </button>
                            <div className={openDropdown === "sidebarApps" ? "menu-dropdown block" : "menu-dropdown hidden"} id="sidebarApps">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item">
                                        <Link to={"/calendar"} className="nav-link" data-key="t-calendar"> Calendar & Scheduling </Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link to="/institution/collaborations/reports" className="nav-link" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="sidebarTasks"
                                           data-key="t-tasks"> Report Center
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/patient-list"} className="nav-link" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="sidebarInvoices" data-key="t-invoices">
                                            Patient Tracker
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/tickets"} className="nav-link" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="sidebarTickets"
                                           data-key="t-supprt-tickets"> Support & Tickets
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/institution/file-manager" className="nav-link"> <span
                                            data-key="t-file-manager">File Manager</span>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </li>






                        <li className="menu-title"> <i className="ri-more-fill"></i> <span data-key="t-components">Uzima -  System</span>
                        </li>

                        <li className="nav-item">
                            <button type="button" className="nav-link menu-link" onClick={() => toggleDropdown("sidebarUI")}>
                                <i className="bx bx-palette"> </i> <span data-key="t-base-ui">Patient Center</span>
                            </button>
                            <div className={openDropdown === "sidebarUI" ? "menu-dropdown block" : "menu-dropdown hidden"} id="sidebarUI">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <ul className="nav nav-sm flex-column">
                                            <li className="nav-item">
                                                <Link to={"/institution/patients"} className="nav-link" data-key="t-alerts">Launch</Link>
                                            </li>


                                            <li className={"nav-item"}>
                                                <button type="button" className="nav-link menu-link" onClick={() => toggleDropdown("sidebarPartners")}>
                                                    <span data-key={"t-advance-ui"}> Patient Management</span>
                                                </button>
                                                <div className={openDropdown === "sidebarPartners" ? "menu-dropdown block" : "menu-dropdown hidden"} id="sidebarPartners">
                                                    <ul className={"nav nav-sm flex-column"}>
                                                        <li className={"nav-item"}>
                                                            <button type="button" className="nav-link menu-link" onClick={() => toggleDropdown("pros")}>Professionals</button>
                                                            <div className={openDropdown === "pros" ? "menu-dropdown block" : "menu-dropdown hidden"} id="pros">
                                                                <ul className={"nav nav-sm flex-column"}>
                                                                    <li className={"nav-item"}>
                                                                        <Link to={"/institutions/partners/1/1"} className={"nav-link"}>Doctors</Link>
                                                                    </li>
                                                                    <li className={"nav-item"}>
                                                                        <Link to={"/institutions/partners/1/2"} className={"nav-link"}>Clinicians</Link>
                                                                    </li>
                                                                    <li className={"nav-item"}>
                                                                        <Link to={"/institutions/partners/1/3"} className={"nav-link"}>Technologists</Link>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </li>

                                                        <li className={"nav-item"}>
                                                            <Link to={"/institutions/partners/3/1"} className={"nav-link"}>Laboratories</Link>
                                                        </li>

                                                        <li className={"nav-item"}>
                                                            <Link to={"/institutions/partners/ambulances/ambulance"} className={"nav-link"}>Ambulances</Link>
                                                        </li>

                                                        <li className={"nav-item"}>
                                                            <Link to={"/institutions/partners/clinics/clinic"} className={"nav-link"}>Clinics</Link>
                                                        </li>

                                                        <li className={"nav-item"}>
                                                            <Link to={"/institutions/partners/hospitals/hosp"} className={"nav-link"}>Hospitals</Link>
                                                        </li>

                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </li>



                        <li className="nav-item">
                            <button type="button" className="nav-link menu-link" onClick={() => toggleDropdown("sidebarAdvanceUI")}>
                                <i className={"bx bx-briefcase-alt"}> </i> <span data-key="t-advance-ui">My Facility</span>
                            </button>
                            <div className={openDropdown === "sidebarAdvanceUI" ? "menu-dropdown block" : "menu-dropdown hidden"} id="sidebarAdvanceUI">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item">
                                        <Link to={"/institution/clinics/launch"} className="nav-link" data-key="t-sweet-alerts">Launch</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/clinics"} className="nav-link" data-key="t-sweet-alerts">My Institution</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/add-clinic"} className="nav-link" data-key="t-nestable-list">Add Facility</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/clinic-details"} className="nav-link" data-key="t-nestable-list">Facility Summary</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/qualifications"} className="nav-link" data-key="t-qualifications">
                                            <i className="bx bx-shield-quarter me-2"></i>My Qualifications
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li className="nav-item">
                            <Link to={"/institution/contracts"} className="nav-link menu-link">
                                <i className="bx bx-file-blank"> </i> <span data-key="t-contracts">Contract Center</span>
                            </Link>
                        </li>

                        <li className="nav-item">
                            <button type="button" className="nav-link menu-link" onClick={() => toggleDropdown("resources")}>
                                <i className={" ri-booklet-line "}> </i> <span data-key="t-resources">Resource Center</span>
                            </button>
                            <div className={openDropdown === "resources" ? "menu-dropdown block" : "menu-dropdown hidden"} id="resources">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item">
                                        <Link to={"/institution/resources"} className="nav-link" data-key="t-sweet-alerts">Launch</Link>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li className="nav-item">
                            <button type="button" className="nav-link menu-link" onClick={() => toggleDropdown("finances")}>
                                <i className={"ri-bank-card-2-line"}> </i> <span data-key="t-resources">Accounting</span>
                            </button>
                            <div className={openDropdown === "finances" ? "menu-dropdown block" : "menu-dropdown hidden"} id="finances">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item">
                                        <Link to={"/institution/billing"} className="nav-link" data-key="t-sweet-alerts">Launch</Link>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li className="nav-item">
                            <button type="button" className="nav-link menu-link" onClick={() => toggleDropdown("devices")}>
                                <i className={"ri-computer-line "}> </i> <span data-key="t-resources">Device management</span>
                            </button>
                            <div className={openDropdown === "devices" ? "menu-dropdown block" : "menu-dropdown hidden"} id="devices">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item">
                                        <Link to={"/institution/devices"} className="nav-link" data-key="t-sweet-alerts">Launch</Link>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li className="nav-item">
                            <button type="button" className="nav-link menu-link" onClick={() => toggleDropdown("equipment")}>
                                <i className={"ri-charging-pile-2-line"}> </i> <span data-key="t-resources">Equipment Collaboration</span>
                            </button>
                            <div className={openDropdown === "equipment" ? "menu-dropdown block" : "menu-dropdown hidden"} id="equipment">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item">
                                        <Link to={"/institution/collaborations/equipment"} className="nav-link" data-key="t-sweet-alerts">Launch</Link>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li className="nav-item">
                            <Link to={"/institution/stakeholders"} className="nav-link menu-link">
                                <i className={"ri-group-line"}> </i> <span data-key="t-stakeholders">Stakeholder Center</span>
                            </Link>
                        </li>

                        <li className="nav-item">
                            <button type="button" className="nav-link menu-link" onClick={() => toggleDropdown("filemgr")}>
                                <i className={"ri-file-cloud-line"}> </i> <span data-key="t-filemgr">My Files</span>
                            </button>
                            <div className={openDropdown === "filemgr" ? "menu-dropdown block" : "menu-dropdown hidden"} id="filemgr">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item">
                                        <Link to={"/institution/file-manager"} className="nav-link" data-key="t-sweet-alerts">Launch</Link>
                                    </li>
                                </ul>
                                <div className="q"></div>
                            </div>
                        </li>


                        </>)}

                        <li className="menu-title"><i className="ri-more-fill"> </i> <span  data-key="t-pages">My Account</span></li>


                        <li className="nav-item">
                            <button type="button" className="nav-link menu-link" onClick={() => toggleDropdown("sidebarPages")}>
                                <i className="bx bx-file"> </i>
                                <span data-key="t-pages">Help & Support</span>
                            </button>
                            <div className={openDropdown === "sidebarPages" ? "menu-dropdown block" : "menu-dropdown hidden"} id="sidebarPages">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item">
                                        <Link to="/institution/faqs" className="nav-link" data-key="t-starter"> FAQs</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/institution/ticket-list" className="nav-link" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="sidebarProfile" data-key="t-profile">
                                            Tickets
                                        </Link>
                                        <div className={openDropdown === "sidebarProfile" ? "menu-dropdown block" : "menu-dropdown hidden"} id="sidebarProfile">
                                            <ul className="nav nav-sm flex-column">
                                                <li className="nav-item">
                                                    <Link to="/institution/create-ticket" className="nav-link"
                                                       data-key="t-simple-page"> Create Ticket </Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link to="/institution/ticket-list" className="nav-link"
                                                       data-key="t-settings"> My Tickets </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/notices"} className="nav-link" data-key="t-team"> Notices</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/timelines"} className="nav-link" data-key="t-timeline"> Timeline </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="#" className="nav-link" data-key="t-maintenance"> Maintenance </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/help"} className="nav-link" data-key="t-coming-soon"> Account Help </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/documentation"} className="nav-link" data-key="t-sitemap"> Documentation </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={"/institution/billing-help"} className="nav-link" data-key="t-search-results"> Billing
                                            help </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/institution/privacy" className="nav-link"><span data-key="t-privacy-policy">Privacy Policy</span>
                                            <span className="badge badge-pill bg-success"
                                                  data-key="t-new">New</span></Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/institution/terms" className="nav-link"><span data-key="t-term-conditions">Term & Conditions</span>
                                            <span className="badge badge-pill bg-success"
                                                  data-key="t-new">New</span></Link>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li className={"nav-item"}>
                            <button type="button" className="nav-link menu-link" onClick={() => toggleDropdown("sidebarBackups")}>
                                <i className="bx bx-bot"></i>
                                <span data-key={"t-backups"}>Easy Backup</span>
                            </button>
                            <div className={openDropdown === "sidebarBackups" ? "menu-dropdown block" : "menu-dropdown hidden"} id="sidebarBackups">
                                <ul className="nav nav-sm flex-column">

                                    <li className="nav-item">
                                        <Link to={"/institution/create-backup"} className="nav-link" data-key="t-backups">Create Backup</Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link to={"/institution/restore-backup"} className="nav-link" data-key="t-backups">Restore Backup</Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link to={"/institution/request-backup"} className="nav-link" data-key="t-backups">My Backups</Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link to={"/institution/request-backup"} className="nav-link" data-key="t-backups">Request Access</Link>
                                    </li>

                                </ul>

                            </div>

                        </li>

                    </ul>
                </div>
            </div>

            <div className="sidebar-background"> </div>
        </div>

        </>
    )
}

export default SideMenu;
